import axios from "axios";
import {
  interceptor,
  GET_YEARLY_BREED_SALES_CONTRACTS_INFO,
  FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS,
  GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY,
} from ".";
import store from "../store";
interceptor(axios, store);

export function getYearlyBreedSalesInfo(type,start_date){
  return {
    type: GET_YEARLY_BREED_SALES_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/breed_dashboard/breedSalesInfo/yearly/contractInfo/${type}/${start_date}`,    
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function fetchBreedDashboardAvailableBreeds(){

  return {
    type: FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed_dashboard/breedDashboard/available`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchAvailableBreedCountWithMinimumBreed(){
  return {
    type: GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed_dashboard/breedDashboard/minimumBreedQuantity/countAvailableBreed`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

